import Vue from "vue";
import Vuetify from "vuetify/lib";

import "remixicon/fonts/remixicon.css";
import "eva-icons/style/eva-icons.css";
import '@mdi/font/css/materialdesignicons.css';

import colors from "./colors";

// import { library } from "@fortawesome/fontawesome-svg-core";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// import { faBars } from "@fortawesome/pro-light-svg-icons";
// import { faVuejs } from "@fortawesome/free-brands-svg-icons";

// import { fas } from "@fortawesome/pro-solid-svg-icons";
// import { far } from "@fortawesome/pro-regular-svg-icons";
// import { fal } from "@fortawesome/pro-light-svg-icons";
// import { fad } from "@fortawesome/pro-duotone-svg-icons";

// Vue.component("font-awesome-icon", FontAwesomeIcon);
// library.add(faBars, faVuejs, fas, far, fal, fad);

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  // icons: {
  //   // component: "icon",
  //   values: {
  //     // set menu to light (default is solid)
  //     menu: {
  //       component: FontAwesomeIcon,
  //       props: {
  //         icon: ["fal", "bars"],
  //       },
  //     },
  //     // reusable custom icon
  //     vuejs: {
  //       component: FontAwesomeIcon,
  //       props: {
  //         icon: ["fab", "vuejs"],
  //       },
  //     },
  //   },
  // },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        blue: colors.blue,
        "dark-blue": colors.darkBlue,
        "light-blue": colors.lightBlue,
        yellow: colors.yellow,
        green: colors.green,
        red: colors.red,
        orange: colors.orange,
        white: colors.white,
        black: colors.black,
        gray: colors.gray,
        purple: colors.purple,
        golden: "#B8860B",
        

        primary: colors.blue,
        secondary: colors.gray.base,
        accent: colors.lightBlue.lighten1,
        error: colors.red.base,
        info: colors.lightBlue.base,
        success: colors.green.base,
        warning: colors.yellow.base,
        background: colors.gray.lighten5,

        primary1: "#1F46CF",
        "primary-light": "#E9ECFA",
        "primary-light1": "#F8FAFD",
        secondary1: "#6D767E",
        secondary2: "#767676",
        "warning-orange": "#F4A425",
        indigo: "#4b0082",
        cyan: "#00FFFF",
        pink: colors.pink,
      },
    },
  },
});
